export const ABI_REQUEST = 'ABI_REQUEST';
export const ABI_DATA = 'ABI_DATA';
export const ABI_ERROR = 'ABI_ERROR';

